import { Component, ElementRef, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { TrainingList } from '../../communication-structure/training-list';
import { TrainingsInAutoTrainingCodeFullModel } from '../../communication-structure/trainings-in-auto-training-code-list';
import { BaseComponent } from './../base/base.component';
import { SelectListComponent } from './../select-list/select-list.component';
import { Skill } from '../../communication-structure/auto-training-code-model';

interface AccordionChildrenFormat {
  id: string;
  assignment: string;
  isExpanded: boolean;
  nodes: AccordionChildrenFormat[] | TrainingList[];
}

@Component({
  selector: 'app-accordion',
  styleUrls: ['./accordion.component.scss'],
  templateUrl: './accordion.component.html'

})

export class AccordionComponent extends BaseComponent {

  title: string;
  selectedAccordionNodes = []
  selectedNodes: Array<AccordionComponent>;
  arrayForDisplay: AccordionChildrenFormat[];
  children: Array<any>;
  snodes: AccordionComponent[];

  @Input() selectList: SelectListComponent;
  @Input() isExpanded: boolean;
  @Input() id: string;
  @Input() root: AccordionComponent;
  @Input() level: number;
  @Input() isLast: boolean;
  @Input() isLeaf: boolean;
  @Input() isEnable: boolean;
  @Input() isEdit: boolean;
  exAssignmentId = '';
  application = '';
  assignment = '';
  skill = '';
  skillId = '';
  autoTrainingCode: TrainingsInAutoTrainingCodeFullModel;
  
  flag : boolean;
    
  private trainingSubCategories = [];

  @Output() handleDblClick = new EventEmitter();

  nodeObservable: Subject<boolean>;

  @Input() set nodes(value: Array<object>) {
    this.children = value;
    this.nodeObservable.next();
  }

  get nodes(): Array<object> {
    return this.children;
  }

  @Input() set header(value: { title: string; version: string }) {
    if (value) {
      if (value.version === undefined) {
        this.title = value.title;
      } else {
        this.title = value.version;
      }
    }
    if (!this.title) {
      this.selectedNodes = new Array<AccordionComponent>();
      if (!this.children || this.children.length === 0) {
        this.nodeObservable.subscribe(
          (data) => this.mapAccordion(),
          (error) => console.log(error)
        );
      } else {
        this.mapAccordion();
      }
    }
  }

 
  /**
   * Creates and returns a map of applications
   */
  private createTrainingCategoryMap() {
    const applicationMap = [];
    for (let i = 0; i < this.children.length; i++) {
      if (!applicationMap[this.children[i].application]) {
        applicationMap[this.children[i].application] = [];
      }
      if (!applicationMap[this.children[i].application][this.children[i].assignment]) {
        applicationMap[this.children[i].application][this.children[i].assignment] = [];
      }
      applicationMap[this.children[i].application][this.children[i].assignment].push(this.children[i]);
    }

    return applicationMap;
  }

  /**
   * Creates and returns the array which is used to display data in the accordion.
   * @param applicationMap A map of trainingCategories
   */
  private createArrayForDisplay(applicationMap) {
    this.arrayForDisplay = [];

    // To maintain category indexes.
    let i = 0, j = 0;

    for (const application in applicationMap) {
      if (applicationMap.hasOwnProperty(application)) {
        this.arrayForDisplay[i] = {
          id: '',
          assignment: '',
          isExpanded: false,
          nodes: []
        };
        if (this.flag === true) {
          this.arrayForDisplay[i].isExpanded = false;
        }
        else {
          this.arrayForDisplay[i].isExpanded = true;
        }
        this.arrayForDisplay[i].id = application;
        this.arrayForDisplay[i].assignment = application;
        const trainingsInTrainingCategoryMap = applicationMap[application];
        for (const assignment in trainingsInTrainingCategoryMap) {
          if (trainingsInTrainingCategoryMap.hasOwnProperty(assignment)) {
            const subCategoryList: AccordionChildrenFormat = {
              id: '',
              assignment: '',
              isExpanded: false,
              nodes: []
            };
            if (this.flag === true) {
              subCategoryList.isExpanded = false;
            }
            else {
              subCategoryList.isExpanded = true;
            }
            subCategoryList.id = application + '.' + (j + 1);
            subCategoryList.assignment = assignment;
            for (let k = 0; k < trainingsInTrainingCategoryMap[assignment].length; k++) {
              subCategoryList.nodes[k] = trainingsInTrainingCategoryMap[assignment][k];
              (subCategoryList.nodes[k] as any).id = subCategoryList.id + '.' + (k + 1);
              (subCategoryList.nodes[k] as any).exAssignmentId = trainingsInTrainingCategoryMap[assignment][k].exAssignmentId;
            }
            (this.arrayForDisplay[i].nodes[j] as any) = subCategoryList;
            j += 1;
          }
        }
        j = 0;
        i += 1;
      }
    }
    return this.arrayForDisplay;
  }

  mapAccordion() {
    const applicationMap = this.createTrainingCategoryMap();
    const arrayForDisplay = this.createArrayForDisplay(applicationMap);
    this.children = arrayForDisplay;
  }

  @Input() get selectedItems(): Array<AccordionComponent> {
    return this.selectedNodes;
  }

  @Input() set index(value) {
    this.id = value;
    this.level = value.toString().split('.').length;
  }

  getComputedStyle(): any {
    return this.sanitization.bypassSecurityTrustStyle('padding: 0px ' + this.level * 15 + 'px;');
  }

  constructor(private sanitization: DomSanitizer, ele: ElementRef) {
    super(ele);
    this.isExpanded = true;
    this.nodeObservable = new Subject<boolean>();
    this.flag = true;
    
  }

  getNodes(): Observable<boolean> {
    return this.nodeObservable.asObservable();
  }

  clearSelection() {
    if (this.selectedNodes) {
      this.selectedNodes.length = 0;
    }
  }

  setSelection(tree: AccordionComponent) {
    if (this.selectedNodes) {
      if (this.isSelected(tree.id) && this.selectedNodes.length > 1) {
        this.selectedNodes = this.selectedNodes.filter((result) => result.id !== tree.id);
      } else if (this.selectedNodes.filter((result) => result.id === tree.id).length === 0) {
        this.pushItemToSelectedNodes(tree);
      }
    }
  }

  isSelected(id: string): boolean {
    if (this.selectedNodes) {
      return this.selectedNodes.filter((result) => result.id === id).length > 0;
    }
    return false;
  }


  onClick(event: Event, action: Action, isCtrl: boolean) {
    if (action === Action.SELECTION) {
      if (!isCtrl) {
        if (this.root.selectedNodes.length === 1 && this.root.selectedNodes.filter(node => node.id === this.id).length === 1) {
          this.itemDblClicked();
          return;
        } else {
          this.root.clearSelection();
        }
      }
      this.root.setSelection(this);
    } else if (action === Action.EXPANSION) {
      this.isExpanded = !this.isExpanded;
    }
    event.stopPropagation();

  }

  embedData(event, node): Event {
    this.selectedAccordionNodes = [];
    const selectedIDs = [];
    if (this.selectedNodes.filter((result) => result.id === node.id).length === 0) {
      if (!event.ctrlKey) {
        this.resetSelection();
      }
      this.setSelection(node);
    }

    // get all ID's of selected nodes
    for (const selectedNode of this.selectedNodes) {
      selectedIDs.push(selectedNode.id);
    }

    for (const child of this.children) {
      for (const nodeItem of (child as any).nodes) {
        for (const subNodes of nodeItem.nodes) {
          if ((subNodes.id).includes(selectedIDs[0])) {
            subNodes.isSelect = false;
            subNodes.title = subNodes.assignment;
            this.selectedAccordionNodes.push(subNodes);
          }
        }
      }
    }
    if (this.flag !== true) {
      event.preventDefault();
    }
    if (this.isEdit) {
      event.preventDefault();
    }
    return event.dataTransfer.setData('text', JSON.stringify(this.selectedAccordionNodes));
  }

  onDragStart(event) {
    if (this.selectList === undefined)
      this.root.embedData(event, this);
  }

  pushItemToSelectedNodes(itemToPush) {
    this.selectedNodes.push(itemToPush);
  }

  resetSelection() {
    this.selectedNodes = new Array<AccordionComponent>();
  }

  itemDblClicked() {
    if (this.flag === true)
      this.handleDblClick.emit();
  }

  private sortTrainingCategoryMap(trainingCategoriesMap) {

    const mainTrainingCategoryKeys = [];
    const sortedTrainingCategories = [];
    for (const application in trainingCategoriesMap) {
      if (trainingCategoriesMap.hasOwnProperty(application)) {
        const sortedSubTrainingCategories = [];
        mainTrainingCategoryKeys.push(application);
      }
    }
    mainTrainingCategoryKeys.sort();
    for (const key of mainTrainingCategoryKeys) {
      sortedTrainingCategories[key] = trainingCategoriesMap[key];
      const currentValue = sortedTrainingCategories[key];
      if (!currentValue[0]) {
        sortedTrainingCategories[key] = this.sortTrainingCategoryMap(sortedTrainingCategories[key]);
      } else {
        sortedTrainingCategories[key] = this.sortBySkill(sortedTrainingCategories[key]);
      }

    }
    return sortedTrainingCategories;
  }

  private sortBySkill(trainingListNode) {
    for (let i = 0; i < trainingListNode.length; i++) {
      for (let j = i; j < trainingListNode.length; j++) {
        if (trainingListNode[i].skill > trainingListNode[j].skill) {
          const tempList = trainingListNode[i];
          trainingListNode[i] = trainingListNode[j];
          trainingListNode[j] = tempList;
        }
      }
    }

    return trainingListNode;
  }
}

enum Action {
  SELECTION = 0,
  EXPANSION = 1
}





// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/accordion/accordion.component.ts